import { dmc } from './products/dmc';
import { goimomi } from './products/goimomi';
import { helinto } from './products/helinto';
import { rj } from './products/rj';
import { tf } from './products/tf';
import { travelone } from './products/travelone';
import { flysync } from './products/flysync';
import { common } from './products/common';

export interface AppConfig {
  companyName: string;
  corporateName: string;
  title: string;
  favicon: string;
  airlineIconsBaseUrl: string;
  templateConfig: string;
  email: string;
  phone: string;
  whatsapp: string;
  address: string;
  agentNavigate: string;
  isFullBGimage: string;
  facebook: string;
  instagram: string;
  twitter: string;
  linkedin: string;
  youtube: string;
  registerAddress: string;
  registerCompanyName: string;
  registerEmail: string;
  registerMobile: string;
  registerNo: string;
  apiUrl: string;
  providerCodes: string[];
  cancellationCharges: string;
  recentSearch: string;
  loginBanner: string;
  aboutUs: string;
  contactUs: string;
  navigator: string;
  google: string;
  isHotel?: boolean;
}

export interface AppConfig {
  companyName: string;
  corporateName: string;
  title: string;
  favicon: string;
  /** Base URL for airline icon images; airlineCode + '.png' is appended. */
  airlineIconsBaseUrl: string;
  templateConfig: string;
  email: string;
  phone: string;
  whatsapp: string;
  address: string;
  agentNavigate: string;
  isFullBGimage: string;
  facebook: string;
  instagram: string;
  twitter: string;
  linkedin: string;
  youtube: string;
  registerAddress: string;
  registerCompanyName: string;
  registerEmail: string;
  registerMobile: string;
  registerNo: string;
  apiUrl: string;
  providerCodes: string[];
  cancellationCharges: string;
  recentSearch: string;
  loginBanner: string;
  aboutUs: string;
  contactUs: string;
  navigator: string;
  google: string;

  // Extra properties found in domains
  sentryDsn?: string;
  encrypt?: string;
  securePayment?: string;
  encryptionSecretKey?: string;
  poweredBy?: boolean | string; // Can be boolean or string 'false'
  isHotel?: boolean;
}

export const domainConfigs: Record<string, Partial<AppConfig>> = {
  'rajeshtravelss.com': rj,
  'travelonego.com': travelone,
  'helinto.com': helinto,
  'dmcleisure.com': dmc,
  'trailfinder.in': tf,
  'trailfinder.com': tf,
  'b2btrailfinder.com': tf,
  'goimomi.com': goimomi,
  'yourtravel.dmcleisure.com': dmc,
  // 'trailfinder.co.in': tf,
  'booking.goimomi.com': goimomi,
  localhost: rj,
  'b2c-common.flysync.in': flysync,
  default: flysync,
};
